module.exports = __webpack_public_path__ + "static/img/shl_certificate_person.460e29c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_certificate_person.jpg
// module id = A9Wx
// module chunks = 5